import { render, staticRenderFns } from "./PriceCommon.vue?vue&type=template&id=b57bf7c4&scoped=true&"
import script from "./PriceCommon.vue?vue&type=script&lang=js&"
export * from "./PriceCommon.vue?vue&type=script&lang=js&"
import style0 from "./PriceCommon.vue?vue&type=style&index=0&id=b57bf7c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57bf7c4",
  null
  
)

export default component.exports